const PLAYER_EVENT_TYPES = {
    KICKED: 1,
    KICKED_TO_LOBBY: 2,
    RESTRICTION_UPDATED: 3,
    GEO_REQUIRED: 4,
    OMG: 100
}


export {PLAYER_EVENT_TYPES}